export const GET_OCCUPATIONS = 'occupations/GET_OCCUPATIONS'
export const GET_OCCUPATIONS_SUCCESSFUL =
  'occupations/GET_OCCUPATIONS_SUCCESSFUL'
export const GET_OCCUPATIONS_FAILURE = 'occupations/GET_OCCUPATIONS_FAILURE'
